import React from 'react';
import { Services } from 'services';
import { Store } from 'store';
import { ShouldRender } from 'components/ShouldRender';
import { PageLoader } from 'components/loaders';
import { getAuthProvider } from 'utils/auth';

export const AuthGuard: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const provider = getAuthProvider();
  const auth0Refresh =
    provider === 'auth0' || provider === null
      ? Services.Auth.useRefreshAccessToken()
      : ({ isLoading: false } as { isLoading: boolean });
  const idmeRefresh =
    provider === 'idme'
      ? Services.Auth.useIdmeRefreshAccessToken()
      : ({ isLoading: false } as { isLoading: boolean });
  const auth0SsoRefresh =
    provider === 'auth0-sso'
      ? Services.Auth.useAuth0SsoRefreshAccessToken()
      : ({ isLoading: false } as { isLoading: boolean });

  const { isAuthenticated } = Store.useUser();
  const isLoading = Boolean(
    auth0Refresh.isLoading || idmeRefresh.isLoading || auth0SsoRefresh.isLoading
  );

  return (
    <React.Fragment>
      {isAuthenticated ? (
        children
      ) : (
        <ShouldRender when={isLoading}>
          <PageLoader />
        </ShouldRender>
      )}
    </React.Fragment>
  );
};
